import { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../config/authContext';
import { getAuth, sendEmailVerification } from 'firebase/auth';
import Logotipo from "../assets/Icons/Logotipo.svg";
import '../styles/Auth.css';

const VerifyEmail = () => {
    const { userLoggedIn } = useAuth();
    const navigate = useNavigate();
    const auth = getAuth();
    const [emailSent, setEmailSent] = useState(false);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        let mounted = true;
        const check = async () => {
            const user = auth.currentUser;
            if (!user) return;
            try {
                await user.reload();
                if (user.emailVerified && mounted) setVerified(true);
            } catch (e) {
                console.warn('Failed to reload user for verification check', e);
            }
        };
        check();
        return () => { mounted = false; };
    }, [auth]);

    const handleSend = async () => {
        const user = auth.currentUser;
        if (!user) return;
        setSending(true);
        setError('');
        try {
            await sendEmailVerification(user);
            setEmailSent(true);
            console.log('Verification email sent from verify page');
        } catch (e) {
            console.error('Error sending verification email', e);
            setError(e?.code === 'auth/too-many-requests' ? 'Too many attempts. Please wait a few minutes and try again.' : 'Could not send verification email. Please try again.');
        } finally {
            setSending(false);
        }
    };

    const handleContinue = async () => {
        const user = auth.currentUser;
        if (!user) return;
        await user.reload();
        if (user.emailVerified) {
            navigate('/questionnaire');
        } else {
            setError('Your email is not verified yet. Please check your inbox.');
        }
    };

    if (!userLoggedIn) {
        return <Navigate to="/auth" replace />;
    }

    if (verified) {
        return <Navigate to="/questionnaire" replace />;
    }

    return (
        <div className="home">
            <header className="navigation-presite-bar">
                <div className="logo-wrapper">
                    <Link to={'/'} className="logo">
                        Frazza
                    </Link>
                </div>
            </header>

            <div className="auth-layout">
                <div className="auth-left-container">
                    <div className="sub-logo">
                        <h1 className="main-heading">Verify your email</h1>
                        <p>We sent a verification link to your email. Please verify to continue.</p>
                    </div>

                    <div className="auth-container">
                        <div className="auth-box">
                            {error && <span className='error-message'>{error}</span>}
                            <button id="authButton" className={sending ? 'disabled' : ''} disabled={sending} onClick={handleSend}>
                                {sending ? 'Sending…' : (emailSent ? 'Resend verification email' : 'Send verification email')}
                            </button>
                            <div className='divider'><span>Then</span></div>
                            <button id="authButton" onClick={handleContinue}>I verified my email, continue</button>
                        </div>
                    </div>
                </div>

                <div className="logo-container">
                    <img src={Logotipo} alt="Logotipo de personas" className="logo-icon4" />
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
